module.exports = __webpack_public_path__ + "img/women-on-phone-unsplash.3204c21d.jpg";